import asyncRoute from '../AsyncRoute'

import { SUPPLIES_ROUTE_URLS } from '../constants'
import getRequestName from '../components/getRequestName'

export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-order-supplies-dom').OrderSupplies
      const requestInfoMaskHoc = require('fc-requests').requestInfoMaskHoc
      const requestInfo$ = require('fc-requests').getFilteredRequestsInProgress$(SUPPLIES_ROUTE_URLS)

      resolve(requestInfoMaskHoc({
        requestInfo$,
        getRequestName,
      })(View))
    }, 'hfty-order-supplies-dom')
  })
}

export default asyncRoute({ getComponent, reducers: [] })
